/* eslint-disable react/prop-types */
import React from 'react';
import LineChart from 'react-linechart';
import 'react-linechart/dist/styles.css';
import { Grid, Typography } from '@mui/material';

const ElevationGraph = (props) => {
  const { dronePlannedAltitude, groundElevation, droneAltitude } = props;

  return (
    <>
      <div className="relative top-0 -left-3%">
        <LineChart
          hideXLabel
          hideYLabel
          interpolate="linear"
          onPointHover={(point) => point.y}
          hidePoints={props.hidePoints}
          width={props.width}
          height={props.height}
          showPoints={props.showPoints}
          data={[
            {
              color: 'gray',
              points: dronePlannedAltitude || [],
              name: 'Planned Alt',
            },
            {
              color: 'blue',
              points: droneAltitude || [],
              name: 'Drone Alt',
            },
            {
              color: 'brown',
              points: groundElevation || [],
              name: 'Ground',
            },
          ]}
        />
      </div>
      <Grid container className="absolute bottom-0 left-6%" spacing={2}>
        {groundElevation && (
          <Grid item>
            <div className="h-2.5 w-5 bg-brown inline-block mr-1.5" />
            <Typography className="inline">Ground</Typography>
          </Grid>
        )}
        {droneAltitude && (
          <Grid item>
            <div className="h-2.5 w-5 bg-blue inline-block mr-1.5" />
            <Typography className="inline">Drone Alt</Typography>
          </Grid>
        )}
        {dronePlannedAltitude && (
          <Grid item>
            <div className="h-2.5 w-5 bg-gray inline-block mr-1.5" />
            <Typography className="inline">Planned Alt</Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default ElevationGraph;
